let instance;

import { remove_token, set_axios_defaults, set_token, get_token, set_defualt_driver_tip } from '../helper/helper';
import config from './../config';
import * as VueGoogleMaps from 'vue2-google-maps';
import Login from "../apis/login";
import Logout from "../apis/logout";
import Wallet from "../apis/wallet";
import Vue from 'vue';
import firebase from "firebase";
import GoogleAuth from '@/config/google_oAuth.js';
import { handleApiError } from "../helper/helper";
import Profile from '../apis/profile';


export const useAuth = (options = {}) => {
  if (instance) return instance;
  instance = new Vue({
    data() {
      return {
        config: config,
        user: null,
        setting: null,
        languages: [],
        logging_done: false,
        restaurant_id: 0,
        google_map_key: null,
        init: false,
        userWalletAmount: '',
        firebaseInitialized: false, // Added for Firebase state tracking
        firebaseApp: null // Added for Firebase app reference
      }
    },
    methods: {
      getUserId() {
        if (!this.user) return null;

        // Handle different response structures
        return this.user.data.id ||
          this.user.id ||
          this.user.user_id ||
          this.user.data.user_id ||
          null;
      },

      // Helper method to get user token
      getUserToken() {
        if (!this.user) return null;

        return this.user.data.token ||
          this.user.token ||
          null;
      },

      // Fixed vendor ID methods with null checks
      setVenodorIdInLocalStorage(vnid) {
        if (vnid) {
          const encodedId = this.base64_encode(vnid.toString());
          if (encodedId) {
            localStorage.setItem('vnid', encodedId);
          }
        }
      },

      getVendorIdFromLocalStorage() {
        const vnid = localStorage.getItem('vnid');
        if (vnid) {
          const decoded = this.base64_decode(vnid);
          return decoded ? parseInt(decoded) : 0;
        }
        return 0;
      },

      // Fixed app logo getter with null checks
      getAppLogo() {
        if (this.setting && this.setting.app_layout && this.setting.app_layout[0].web_horizontal_logo) {
          return this.config.applogo + this.setting.app_layout[0].web_horizontal_logo;
        } else if (this.setting && this.setting.app_logo) {
          return this.config.masterApplogo + this.setting.app_logo;
        }
        return '';
      },

      // Fixed favicon getter
      getAppFavicon() {
        if (this.setting && this.config.applogo && this.setting.app_layout && this.setting.app_layout[0].web_fav_logo) {
          return this.config.applogo + this.setting.app_layout[0].web_fav_logo;
        }
        return '';
      },

      logout(data, callback) {
        Logout.CheckLogout(data).then(res => {
          this.logging_done = false;
          this.user = '';
          remove_token();
          callback('sign-in')
        });
      },

      login(request, callback) {
        if (!request) {
          console.error('Login request data is required');
          return;
        }

        Login.CheckLogin(request).then((response) => {
          // Handle different response structures
          if (response && (response.status == 200 || response.data.status == true)) {
            const responseData = response.data || response;
            const token = responseData.data.token || responseData.token;

            if (token) {
              this.user = responseData;
              this.setting = this.setting || responseData.settings;
              this.logging_done = true;
              set_token(token);
              set_axios_defaults(token);
              set_defualt_driver_tip(0);

              if (typeof callback == 'function') {
                callback('home');
              }
            } else {
              const message = responseData.message || 'Login failed';
              this.$toasted.error(message, { duration: 2000 });
            }
          } else {
            const message = response.data.message || response.message || 'Login failed';
            this.$toasted.error(message, { duration: 2000 });
          }
        }).catch((error) => {
          let errorMessage = '';
          errorMessage = error.response.data.message

          this.$toasted.error(errorMessage, { duration: 2000 });
        });
      },

      setUser(callback, token = "") {
        if (typeof callback !== 'function') {
          console.error('Callback must be a function');
          return;
        }

        const userToken = token || get_token();
        if (userToken) {
          set_axios_defaults(userToken);
          Profile.GetProfile()
            .then(response => {
              // Handle different response structures
              if (response && (response.status == 200 || response.data.status == true)) {
                this.logging_done = true;

                // Handle nested data structure
                if (response.data.data) {
                  this.user = response.data;
                } else if (response.data) {
                  this.user = { data: response.data };
                } else {
                  this.user = response;
                }

                // Set vendor ID if available
                const vendorId = atob(localStorage.getItem('vnid') || '');
                if (vendorId) {
                  this.setVenodorIdInLocalStorage(vendorId);
                }

                this.getGoogleMapApiKey();
                this.setFireBaseSettings();
                callback('home');
              } else {
                console.warn('Invalid user profile response:', response);
                this.logging_done = false;
                this.user = null;
                callback('sign-in');
              }
            })
            .catch(error => {
              console.error("Error fetching user details:", error);
              this.logging_done = false;
              this.user = null;
              callback('sign-in');
            });
        } else {
          this.logging_done = false;
          callback('sign-in');
        }
      },

      setUserDetails(data) {
        this.user = data;
      },

      setRegisterUserDetails(data, token = '') {
        this.user = data;
        this.logging_done = true;
        set_token(token)
        set_defualt_driver_tip(0);
        set_axios_defaults(token)
      },

      getUserDetails() {
        return this.user;
      },

      setVendorSettings(data) {
        if (!data) {
          console.error('Vendor settings data is required');
          return;
        }

        Login.getVendorSettings(data).then(response => {
          // Handle different response structures
          if (response && (response.status == 200 || response.data.status == true)) {
            const responseData = response.data || response;
            this.setting = responseData.data || responseData;
            this.init = true;

            if (this.setting) {
              this.setRootStyle();

              // Set country code with null check
              if (this.setting.country_code) {
                localStorage.setItem('cntrycode', this.base64_encode(this.setting.country_code));
              }

              // Set delivery zone availability
              const isDeliveryZoneAvailable = this.setting.is_vendor_listing == true ? this.setting.is_delivery_zone_available : false;
              localStorage.setItem('is_delivery_zone_available', isDeliveryZoneAvailable);

              // Set vendor ID
              if (this.setting.vendor_id) {
                this.setVenodorIdInLocalStorage(this.setting.vendor_id);
                window.axios.defaults.headers.common['x-vendor-id'] = this.setting.vendor_id;
              }

              this.getGoogleMapApiKey();
              this.setFireBaseSettings();
              this.setSocialLoginAuthKey();
              this.setFbAppID();
            }
          } else {
            console.warn('Invalid vendor settings response:', response);
            this.setting = null;
            this.init = true;
            this.removeVendorIdFromLocalStorage();
          }
        }).catch(error => {
          console.error('Error fetching vendor settings:', error);
          this.setting = null;
          this.init = true;
          this.removeVendorIdFromLocalStorage();
        });
      },

      setRootStyle() {
        if (this.setting && this.setting.web_settings) {
          let styleEl = document.createElement('style');
          let themePrimaryColor = this.setting.web_settings.theme_primary_color ? this.setting.web_settings.theme_primary_color : '#00000e';
          let newRgbPrimary = (this.hexToRgb(themePrimaryColor).r + ',' + this.hexToRgb(themePrimaryColor).g + ',' + this.hexToRgb(themePrimaryColor).b);

          let themeSecondaryColor = this.setting.web_settings.theme_secondary_color ? this.setting.web_settings.theme_secondary_color : '#d8d4d4';
          let fontPrimaryColor = this.setting.web_settings.text_primary_color ? this.setting.web_settings.text_primary_color : '#000000';
          let fontSecondaryColor = this.setting.web_settings.text_secondary_color ? this.setting.web_settings.text_secondary_color : '#d0c8c8';
          let footerBackgroundColor = this.setting.web_settings.footer_background_color ? this.setting.web_settings.footer_background_color : '#ffffff';
          let footerFontColor = this.setting.web_settings.footer_text_color ? this.setting.web_settings.footer_text_color : '#000000';
          let homeSliderBackgroundColor = this.setting.web_settings.home_slider_background_color ? this.setting.web_settings.home_slider_background_color : '#f5f5f5';

          let themeButtonPrimaryColor = this.setting.web_settings.button_primary_color ? this.setting.web_settings.button_primary_color : '#00000e';
          let newButtonBackColor = (this.hexToRgb(themeButtonPrimaryColor).r + ',' + this.hexToRgb(themeButtonPrimaryColor).g + ',' + this.hexToRgb(themeButtonPrimaryColor).b);

          let buttonSecondaryColor = this.setting.web_settings.button_secondary_color ? this.setting.web_settings.button_secondary_color : '#d8d4d4';

          let buttonTextPrimaryColor = this.setting.web_settings.button_text_primary_color ? this.setting.web_settings.button_text_primary_color : '#ffffff';
          let buttonTextSecondaryColor = this.setting.web_settings.button_text_secondary_color ? this.setting.web_settings.button_text_secondary_color : '#ffffff';
          styleEl.innerHTML = ':root{--theme-primary:' + newRgbPrimary + ';--theme-secondary:' + themeSecondaryColor + ' ; --theme-font-primary:' + fontPrimaryColor + ' ;--theme-font-secondary:' + fontSecondaryColor + '; --theme-footer-backgroundColor:' + footerBackgroundColor + '; --theme-footer-fontColor:' + footerFontColor + ';--theme-homeSlider:' + homeSliderBackgroundColor + '; --theme-primary-button-color:' + newButtonBackColor + ';--theme-button-text-primary-color:' + buttonTextPrimaryColor + ';--theme-button-text-second-color:' + buttonTextSecondaryColor + '; --theme-button-secondary-color:' + buttonSecondaryColor + ';}';
          document.head.appendChild(styleEl);
          const descEl = document.querySelector('head meta[name="description"]');
          const titleEl = document.querySelector('head title');
          const keywordEl = document.querySelector('head meta[name="keywords"]');
          descEl.setAttribute('content', this.setting.web_settings.meta_description ? this.setting.web_settings.meta_description : '');
          titleEl.textContent = this.setting.web_settings.title ? this.setting.web_settings.title : '';
          keywordEl.setAttribute('content', this.setting.web_settings.keywords ? this.setting.web_settings.keywords : '');
          document.querySelector('[type="image/x-icon"]').setAttribute('href', this.getAppFavicon());
        }
      },

      hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      },

      getVendorId() {
        return (this.setting && this.setting.vendor_id) ? this.setting.vendor_id : this.getVendorIdFromLocalStorage();
      },

      removeVendorIdFromLocalStorage() {
        localStorage.removeItem('vnid');
      },

      setLanguages(languages) {
        this.langauges = languages;
      },

      getLangauge(abbr) {
        return this.langauges.find(l => l.abbrivation == abbr);
      },

      getTaxName() {
        return this.setting && this.setting.tax_name_primary_lang || 'Service tax';
      },

      getRestaurantName() {
        return this.setting && this.setting.restaurant_name || 'Vendor';
      },

      setRestauranID(restaurant_id) {
        this.restaurant_id = restaurant_id;
      },

      getAppName() {
        return (this.setting && this.setting.app_name) ? this.setting.app_name : 'Deonde';
      },

      getFlatIcon() {
        if (this.setting && this.setting.app_layout && this.setting.app_layout[0].web_square_logo) {
          return this.config.applogo + this.setting.app_layout[0].web_square_logo;
        }
        else if (this.setting && this.setting.app_logo) {
          return this.config.masterApplogo + this.setting.flat_icon;
        }
      },

      getSigninImage() {
        return (this.setting && this.setting.login_signup_page_image) ? this.config.signInLogo + this.setting.login_signup_page_image : '';
      },

      getGoogleMapApiKey() {
        let apiKey = '';

        // Try different possible locations for the API key
        if (this.setting) {
          apiKey = this.setting.google_map_key ||
            this.setting.google_map_api_key ||
            this.setting.google_api_key || '';
        }

        if (!apiKey) {
          console.warn('Google Maps API key not found in settings');
          window.google_map_key = '';
          return '';
        }

        window.google_map_key = apiKey;

        // Only initialize if key has changed
        if (this.google_map_key !== window.google_map_key) {
          try {
            Vue.use(VueGoogleMaps, {
              load: {
                key: window.google_map_key,
                libraries: "places",
                // Add error handling
                callback: () => {
                  console.log('Google Maps API loaded successfully');
                  this.google_map_key = window.google_map_key;
                },
                error: (error) => {
                  console.error('Google Maps API failed to load:', error);
                  window.google_map_key = '';
                  this.google_map_key = '';
                }
              },
              installComponents: true,
            }).$gmapApiPromiseLazy().then(() => {
              this.google_map_key = window.google_map_key;
              console.log('Google Maps components installed');
            }).catch(error => {
              console.error('Google Maps components failed to install:', error);
              window.google_map_key = '';
              this.google_map_key = '';
            });
          } catch (error) {
            console.error('Error initializing Google Maps:', error);
            window.google_map_key = '';
            this.google_map_key = '';
          }
        }

        return window.google_map_key;
      },

      setSocialLoginAuthKey() {
        if (this.setting.web_settings && this.setting.web_settings.google_client_id) {
          const gauthOption = {
            clientId: this.setting.web_settings.google_client_id,
            scope: 'profile email',
            prompt: 'select_account'
          }
          Vue.use(GoogleAuth, gauthOption);
        }
      },

      setFbAppID() {
        return this.setting && this.setting.web_settings && this.setting.web_settings.fb_app_id;
      },

      // FIXED Firebase Settings Method
      setFireBaseSettings(appName = '') {
        // If Firebase is already initialized, don't initialize again
        if (this.firebaseInitialized && this.firebaseApp) {
          console.log('Firebase already initialized, skipping...');
          return this.firebaseApp;
        }

        if (
          (this.setting) &&
          (this.setting.firebase_apiKey && this.setting.firebase_apiKey != '') &&
          (this.setting.firebase_authDomain && this.setting.firebase_authDomain != '') &&
          (this.setting.firebase_databaseURL && this.setting.firebase_databaseURL != '') &&
          (this.setting.firebase_projectId && this.setting.firebase_projectId != '') &&
          (this.setting.firebase_storageBucket && this.setting.firebase_storageBucket != '') &&
          (this.setting.firebase_messagingSenderId && this.setting.firebase_messagingSenderId != '') &&
          (this.setting.firebase_appId && this.setting.firebase_appId != '')
        ) {
          const config = {
            apiKey: this.setting.firebase_apiKey,
            authDomain: this.setting.firebase_authDomain,
            databaseURL: this.setting.firebase_databaseURL,
            projectId: this.setting.firebase_projectId,
            storageBucket: this.setting.firebase_storageBucket,
            messagingSenderId: this.setting.firebase_messagingSenderId,
            appId: this.setting.firebase_appId
          };

          try {
            const targetAppName = appName || '[DEFAULT]';

            // Check if Firebase apps array exists and has apps
            if (firebase.apps && firebase.apps.length > 0) {
              // Use ES5 compatible find method for Vue 2
              var existingApp = null;
              for (var i = 0; i < firebase.apps.length; i++) {
                if (firebase.apps[i].name === targetAppName) {
                  existingApp = firebase.apps[i];
                  break;
                }
              }

              if (existingApp) {
                console.log('Firebase app "' + targetAppName + '" already exists');
                this.firebaseInitialized = true;
                this.firebaseApp = existingApp;
                return existingApp;
              }
            }

            // Initialize Firebase app
            var app;
            if (appName !== '') {
              app = firebase.initializeApp(config, appName);
            } else {
              app = firebase.initializeApp(config);
            }

            // Set state
            this.firebaseInitialized = true;
            this.firebaseApp = app;

            console.log('Firebase app "' + targetAppName + '" initialized successfully');
            return app;

          } catch (error) {
            console.error('Error initializing Firebase:', error);

            if (error.code === 'app/duplicate-app') {
              console.log('Firebase app already exists, getting existing app');
              try {
                var existingApp = firebase.app(appName);
                this.firebaseInitialized = true;
                this.firebaseApp = existingApp;
                return existingApp;
              } catch (getAppError) {
                console.error('Error getting existing Firebase app:', getAppError);
              }
            }
          }
        } else {
          console.warn('Firebase configuration incomplete');
        }
      },

      // Add helper method to reset Firebase if needed
      resetFirebase() {
        try {
          if (this.firebaseApp) {
            this.firebaseApp.delete();
          }
          this.firebaseInitialized = false;
          this.firebaseApp = null;
          console.log('Firebase app has been reset');
        } catch (error) {
          console.error('Error resetting Firebase:', error);
        }
      },

      // Add base64 encode/decode methods if not already present
      base64_encode(str) {
        try {
          return btoa(str);
        } catch (error) {
          console.error('Error encoding base64:', error);
          return '';
        }
      },

      base64_decode(str) {
        try {
          return atob(str);
        } catch (error) {
          console.error('Error decoding base64:', error);
          return '';
        }
      }
    }
  });
  return instance;
}

export default {
  install(Vue, options = {}) {
    Vue.prototype.$auth = useAuth(options);
  }
};